import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCookies from 'vue-cookies'
import Vuex from 'vuex';
import VueProgressiveImage from 'vue-progressive-image'
import i18n from './i18n'
import * as VueGoogleMaps from 'vue2-google-maps'
import lang from './utils/lang'
import Constants from './constants'
import VueGtag from 'vue-gtag'
import VueLazyload from 'vue-lazyload'

import store from './store'
import mixin from './mixin'

import '@/assets/tailwind.css'

Vue.use(VueCookies)
Vue.use(Vuex)
Vue.use(mixin)
Vue.use(VueProgressiveImage)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API,
    libraries: 'places',
    region: 'JP',
    language: lang
  }
})
Vue.use(
  VueGtag,
  {
    config: { id: 'G-YM66EKBYTV' }
  },
  router
)
const loadimage = require('./assets/images/loading.gif')
const errorimage = require('./assets/images/no-image.jpg')
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
})

Vue.config.productionTip = false

// NOTE: 使っているパッケージでセッションクッキーが使えないので、想定していない文字列を適当にセット
// https://github.com/cmp-cc/vue-cookies/blob/35f74bc2d00409413e3f4eb7ef488716f4d05220/vue-cookies.js#L57
Vue.$cookies.config('Session')

import * as filters from './utils/filters';
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
})

// NOTE: リンクで直接マップにアクセスする際にtokenが渡された場合はセットする
// TODO: App.vueに移動した方がよさそう
router.beforeEach((to, from, next) => {
  const token = to.query && to.query.token
  const current = store.getters['user/getToken']
  const appId = store.getters['user/getAppId']
  if (token && (token !== current)) {
    store.dispatch('user/setToken', token)
  } else if (appId !== null && appId !== Constants.API_ID) {
    store.dispatch('resetAll')
    // リカバリーコードが残っている場合は自動的に復旧
    const recoveryCode = store.getters['user/getRecoveryCode']
    if (!token && recoveryCode) {
      store.dispatch('plans/recoveryToken', recoveryCode)
        .then(() => {
          store.dispatch('favorites/fetchAll')
        })
    }
  }
  next()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount("#app")
